export default __webpack_public_path__ + "static/media/elevate-gry-poster-3.f7457e42.jpg";